/**
 * Returns the correct indefinite article ("a" or "an") for a given word.
 * Handles vowel sounds including acronyms like HVAC (pronounced "aitch-vee-ay-see").
 */
export function getArticle(word) {
  if (!word || !word.trim()) return 'a';
  const firstLetter = word.trim().toLowerCase()[0];
  const firstWord = word.trim().toLowerCase().split(/\s+/)[0];
  const vowelLetters = ['a', 'e', 'i', 'o', 'u'];

  // Words starting with 'h' where 'h' is silent or pronounced as a vowel sound
  // HVAC = "aitch-vee-ay-see" → vowel sound → "an"
  // But "handyman", "house cleaner", "hair stylist" → consonant 'h' → "a"
  const hConsonantStarts = ['handyman', 'house', 'hair', 'home', 'hardwood', 'heating'];

  if (vowelLetters.includes(firstLetter)) {
    return 'an';
  }

  if (firstLetter === 'h') {
    if (hConsonantStarts.some(w => firstWord.startsWith(w))) {
      return 'a';
    }
    // Default for 'h' words: "an" (covers HVAC and other acronyms)
    return 'an';
  }

  return 'a';
}

/** Uppercase version: "A" or "AN" */
export function getArticleUpper(word) {
  return getArticle(word).toUpperCase();
}
